import { render, staticRenderFns } from "./u-tit-wrap-line.vue?vue&type=template&id=468b10e8&scoped=true&"
import script from "./u-tit-wrap-line.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-line.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-wrap-line.vue?vue&type=style&index=0&id=468b10e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b10e8",
  null
  
)

export default component.exports